import React from "react";
import NavigationBarBlur from "../../components/NavigationBarBlur/NavigationBar";
import Footer from "../../components/FooterAltBlack/Footer";
import { Button, Container } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import MagazineCover from '../../images/v5/vol5.jpg'
import one from '../../images/v5/1 .jpg'
import two from '../../images/v5/2.jpg'
import three from '../../images/v5/3.jpg'
import four from '../../images/v5/4.jpg'
import five from '../../images/v5/5.jpg'
import six from '../../images/v5/6.jpg'
import "./style.css"
import { Link } from "react-router-dom";

export const VolumeFive = () => {
    return(
        <div className="VolumeFive">
        &nbsp;
            <nav>     
                <NavigationBarBlur/>
                <Link to="/"><h1 id="h1-white">SENSITIVE CONTENT</h1></Link>
            </nav>
            <main id="magazineFeatures-5">
                <Container>
                        <Row>
                            <Col lg={true}>
                            <a href="https://www.happydevilboy.com/product/sensitive-content-magazine-vol-4" target="_blank" rel="noopener noreferrer"><img src={MagazineCover} alt="Magazine Cover" width="100%" /></a><br/><br/>
                        
                            </Col>
                            <Col lg={true}>
                            <br/>
                            <h2>VOLUME 5</h2>
                            <p>
                           Includes a curated display of art and photography from LGBTQ+ creators, which have previously been censored or removed by social media platforms. The selection spans provocative and challenging visuals to those that stimulate discourse on the thin line of online censorship and comprises the core of Sensitive Content magazine.
                                <br/>
                                <br/>
                                @_doommutt_ @antipalindrome @bearpadart @betty_wite_out @bradypappas @david_handforth @eratic00 @horsegurlpress @ihatealejandrito @jonzu @joshuajenkinsart @justcantstahp @kadenbarddawson @lao_xie_xie @lightpainterr @marhyev @matchesticles @moral_anatomy @ms.mykie @pipipi.t @pocketsizepapi @ryaninwardslopez.photo @rylie4ever @sashachaika  @savage.battaglia @shotbymoondogg @sofiya.loriashvili @sowden_studio @stevelovettnz @straight.panic @strapon_svinopas @trees_heil @vida.b.art @wallyworldweb @willmnichols
                                <br/>
                                <br/>
                               Cover @shotbymoondogg
                            </p>
                            <p>
                            6.5" x 9"<br/>
112 pages<br/>
Perfect bound<br/>
Printed in the USA<br/>
                            </p>
                            <a href="https://happydevilboy.bigcartel.com/product/sensitive-content-magazine-vol-5" target="_blank" rel="noopener noreferrer"><Button>BUY NOW</Button></a>
                            </Col>
                        </Row>
                </Container>
            </main>
            <div id="featuresImages">
                <img src={one} alt="1" width="100%"/>
                <img src={two} alt="2" width="100%"/>
                <img src={three} alt="3" width="100%"/>
                <img src={four} alt="4" width="100%"/>
                <img src={five} alt="5" width="100%"/>
                <img src={six} alt="6" width="100%"/>
            </div>
            <Footer/>
        </div>
    )
}

